// extracted by mini-css-extract-plugin
export default {"header":"Header_header__QJfsy","innerCol":"Header_innerCol__thXMs","logo":"Header_logo__eQM7L","B2bLink":"Header_B2bLink__nWqdP","sideMenu":"Header_sideMenu__qc1Vi"};